import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RootRouter from './RootRouter';
import { PrivacyPage } from '../PrivacyPage';
import { DownloadPage } from '../DownloadPage';
import { CasdoorCallback } from './callback';

import GraphQLClient from '../../services/graphql/graphql-client';
import { ApolloProvider } from '@apollo/client';
import { CasdoorContextProvider } from './casdoor.context';
import { IdentityContextProvider } from './identity.context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ToastContainer } from 'react-toastify';
import { PlatformDetector } from './platform';
import { AppVersionGate } from './AppVersionGate';

const queryClient = new QueryClient();

const basename = import.meta.env.ROOT_URL_PATH_NAME as string;

export const App: React.FC = () => {
  return (
    <PlatformDetector>
      <AppVersionGate>
        <QueryClientProvider client={queryClient}>
          <ApolloProvider client={GraphQLClient}>
            <BrowserRouter basename={basename}>
              <CasdoorContextProvider>
                <Routes>
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/download" element={<DownloadPage />} />
                  <Route path="/callback" element={<CasdoorCallback />} />
                  <Route
                    path="*"
                    element={
                      <IdentityContextProvider>
                        <RootRouter />
                      </IdentityContextProvider>
                    }
                  />
                </Routes>
              <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              </CasdoorContextProvider>
            </BrowserRouter>
          </ApolloProvider>
        </QueryClientProvider>
      </AppVersionGate>
    </PlatformDetector>
  );
};
